import { useState } from 'react';

const OTP_LENGTH = 6;

export function useOtpForm() {
  const [otpValue, setOtpValue] = useState<string>('');
  const [otpVerificationError, setOtpVerificationError] = useState<
    string | null
  >(null);

  const resetOtp = () => {
    setOtpValue('');
    setOtpVerificationError(null);
  };

  const handleOtpChange = (value: string) => {
    const numeric = value.replace(/\D/g, '').slice(0, OTP_LENGTH);
    setOtpValue(numeric);
  };

  return {
    otpValue,
    otpVerificationError,
    setOtpVerificationError,
    handleOtpChange,
    resetOtp,
    otpLength: OTP_LENGTH
  };
}
